import { ValidateObject } from './../../../../front-models/fileToImport';
import { LocationType } from '~/models/modules/locationType';
import { EntityPallet } from './../../../../models/modules/entityPallet';
import { EntityTruck } from './../../../../models/modules/entityTruck';
import { Component, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation, enableProdMode, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn } from '@angular/forms';
import { EditService, FieldAccessorPipe, GridComponent, GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
// import { ImportService } from 'src/app/_services/import';
import {
  FileToImport,
  NewRecordObject,
} from '~/front-models/fileToImport';
import { ImportService } from '~/services/modules/stocks/import';
import { ImportComponent } from '../import.component';
import { FormatService } from '~/services/administration.ts/format';
import { DateFormatPipe } from '~/shared/pipes/dateFormat';
import {
  PersonImportErrorType,
  ValidateImportResultItem,
} from '~/front-models/personImportError';
import { getEnumValueFromKey } from '~/helpers/convertEnum';
import { guid } from '@progress/kendo-angular-common';
const itemIndex = (item: any, data: any[]): number => {
  for (let idx = 0; idx < data.length; idx++) {
    if (data[idx].Id === item.Id) {
      return idx;
    }
  }

  return -1;
};

//const cloneData = (data: any[]) => JSON.parse(JSON.stringify(data));
const cloneData = (data: any[]) => JSON.parse(JSON.stringify(data));

@Component({
    selector: 'stocks-import-validation',
    templateUrl: './validation.html',
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'stocks-import-validation',
    },
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImportValidationComponent implements OnInit, OnDestroy {
  _gridView: GridDataResult;
   _originalData: any[] = [];
  public _originalData2: any[] = [];
  _pageSize = 10;
  _skip = 0;
  _fileExcelData: any;
  _dataToImport: any = [];
  @Input()_selectedModel: FileToImport;
  @Input() _mappedFields: any = [];
  _errorCount: number = 0;
  _gridColumnsName: any[] = [];
  _hasChanges: boolean;
  _indexToBeRemoved: number[] = [];
  selectedItemsEnable: boolean;
  requiredColumnNames : any = [];
  gridFileds: FormGroup = new FormGroup({});
  showErrorsOnly: boolean = true;
  TempDataToImport: any = [];
  _datePickerFormat: any;
  PersonImportErrorType = PersonImportErrorType;
  public get f(): { [key: string]: AbstractControl } { return this.gridFileds.controls; }
  @ViewChild(GridComponent) private grid: GridComponent;
  constructor(
    private _importComponent: ImportComponent,
    private _importService: ImportService,
    private formBuilder: FormBuilder,
    private _formatService: FormatService,
    private _dateFormtatPipe: DateFormatPipe
  ) { }
  ngOnInit() {
    this._datePickerFormat = this._formatService.dateFormat;

    this._fileExcelData = this._importComponent.fileExcelData;
    //this._selectedModel = this._importComponent.selectedModel;

    let record: any;
    this.requiredColumnNames = [];

    for (const excelRecord of this._fileExcelData) {
      record = {};
      for (const selectedModelRecord of this._selectedModel.columns) {

        // Get Required Columns
        if(selectedModelRecord.required && !selectedModelRecord.entity)
        {
          var ColumnExist = this.requiredColumnNames.filter((x: any) => x.ObjectField == selectedModelRecord.name);
          if(ColumnExist.length == 0)
          {
            this.requiredColumnNames.push(
              {ObjectField: !selectedModelRecord.entity? selectedModelRecord.name : selectedModelRecord.entity,
                 requiredColumnName: selectedModelRecord.mappedName });
          }

        }

        if(selectedModelRecord.required && selectedModelRecord.entity)
        {
          var ColumnExist = this.requiredColumnNames.filter((x: any) => x.ObjectField == selectedModelRecord.entity);
          if(ColumnExist.length == 0)
          {
            this.requiredColumnNames.push({ObjectField:selectedModelRecord.entity, requiredColumnName: selectedModelRecord.mappedName });
          }
        }
        /////
        if (selectedModelRecord.mappedNameToValidate) {
          if (!selectedModelRecord.required
            || selectedModelRecord.required
            //&& excelRecord[selectedModelRecord.mappedNameToValidate]

            ) {
            if (!selectedModelRecord.entity) {
              if (!selectedModelRecord.fieldName) {
                record[selectedModelRecord.name] =
                  excelRecord[selectedModelRecord.mappedNameToValidate];
              } else {
                record[selectedModelRecord.name] = {
                  [selectedModelRecord.fieldName]: excelRecord[selectedModelRecord.mappedNameToValidate]
                }
              }


            } else {
              if (selectedModelRecord.entityRelation === 'OneToOne') {
                if (!record[selectedModelRecord.entity]) {
                  if (!selectedModelRecord.fieldName) {
                    record[selectedModelRecord.entity] = new Object();
                  } else {
                    if (!record[selectedModelRecord.entity])
                    record[selectedModelRecord.entity] = new Object();
                    record[selectedModelRecord.entity][selectedModelRecord.name] = new Object({
                      [selectedModelRecord.fieldName]: excelRecord[selectedModelRecord.mappedNameToValidate]
                    })
                  }
                }
                if (!selectedModelRecord.fieldName) {
                  record[selectedModelRecord.entity][selectedModelRecord.name] = excelRecord[selectedModelRecord.mappedNameToValidate];
                } else {
                  ////////////////////////////////
                  if(!record[selectedModelRecord.entity][selectedModelRecord.name])
                  {
                    record[selectedModelRecord.entity][selectedModelRecord.name] =
                    { [selectedModelRecord.fieldName]: excelRecord[selectedModelRecord.mappedNameToValidate]
                    };
                  }

                  else
                  {
                    record[selectedModelRecord.entity][selectedModelRecord.name][selectedModelRecord.fieldName] =
                    excelRecord[selectedModelRecord.mappedNameToValidate]
                  }

                   ///////////////////
                  // record[selectedModelRecord.entity][selectedModelRecord.name] =
                  // { [selectedModelRecord.fieldName]: excelRecord[selectedModelRecord.mappedNameToValidate]
                  // };
                  //
                }
              } else {
                if (!record[selectedModelRecord.entity]) {
                  record[selectedModelRecord.entity] = [];
                  //Temp Array
                  record['TempArray ' + selectedModelRecord.entity] = {};
                  ////
                  if (!selectedModelRecord.fieldName) {
                    record[selectedModelRecord.entity].push(new Object());
                     //Temp Array
                    record['TempArray ' + selectedModelRecord.entity] = new Object();
                  ////
                  } else {
                    // record[selectedModelRecord.entity].push(new Object({
                    //   [selectedModelRecord.fieldName]: excelRecord[selectedModelRecord.mappedNameToValidate]
                    // }));
                    record[selectedModelRecord.entity].push(new Object({
                      [selectedModelRecord.name]: new Object({
                        [selectedModelRecord.fieldName]: excelRecord[selectedModelRecord.mappedNameToValidate]

                      })

                    }));
                     //Temp Array
                  record['TempArray ' + selectedModelRecord.entity] = new Object({
                    [selectedModelRecord.name]: new Object({
                      [selectedModelRecord.fieldName]: excelRecord[selectedModelRecord.mappedNameToValidate]

                    })
                  });
                  ////
                  }
                }
                if (!selectedModelRecord.fieldName) {
                  record[selectedModelRecord.entity][0][selectedModelRecord.name] = excelRecord[selectedModelRecord.mappedNameToValidate];
                  //Temp Array
                  record['TempArray ' +  selectedModelRecord.entity][selectedModelRecord.name] = excelRecord[selectedModelRecord.mappedNameToValidate];
                  ////
                  if (selectedModelRecord.isCustomField) {
                    record[selectedModelRecord.name] = excelRecord[selectedModelRecord.mappedNameToValidate];
                  }
                } else {
                  record[selectedModelRecord.entity][0][selectedModelRecord.name] = {
                    [selectedModelRecord.fieldName]: excelRecord[selectedModelRecord.mappedNameToValidate]
                  }
                  //Temp Array
                  record['TempArray ' +  selectedModelRecord.entity][selectedModelRecord.name] = {
                    [selectedModelRecord.fieldName]: excelRecord[selectedModelRecord.mappedNameToValidate]
                  }
                  ////
                }
              }
            }


          } else {

          }
        }
      }




      if (record && Object.keys(record).length) {

        this._dataToImport.push(record);
      }
    }

    // Fill grid columns name if mappedNameToValidate exists
    this._selectedModel.columns.forEach((element) => {
      if (element.mappedNameToValidate) {
        this._gridColumnsName.push({
          entity: element.entity,
          entityRelation: element.entityRelation,
          label: element.label,
          mappedName: element.mappedName,
          required: element.required,
          //name:  element.name,
           name: element.name,
         // name: this.getPropByString(element, element.name),
          type: element.type,
         // fieldName: element.entityRelation == "OneToOne" ? element.name : undefined,
         fieldName: element.fieldName,
         //fieldName: element.name && element.name.split(".").length > 1 ? element.name.split(".")[1]  : element.name,
          isCustomField: element.isCustomField,
          Path: !element.entity  ? element.name :
           element.entity && !element.fieldName ? element.entity + "." + element.name
          : element.entity && element.fieldName ? element.entity + "." + element.name + "." + element.fieldName : ""
        });

      }
    });

    this._gridColumnsName.push({
      label: 'Error',
      name: 'Error',
      type: ''
    });

    //  if(this._importComponent.importObject.dataToImport
    //   && this._importComponent.importObject.dataToImport.length > 0)
    //   {
    //     this._dataToImport = this._importComponent.importObject.dataToImport;
    //     //this.assignExistingProperties();
    //   }


    this._importComponent.updateImportObject(this._dataToImport);
    this._originalData = [...cloneData(this._dataToImport)];
    this.validateData();
  }
  assignExistingProperties() {
    this._dataToImport.forEach((element: any, index: any) => {
      let Keys = Object.keys(element);
      Keys.forEach(key => {
        if(this._importComponent.importObject.dataToImport[index] &&
          this._importComponent.importObject.dataToImport[index][key])
          element[key] = this._importComponent.importObject.dataToImport[index][key];
      });

    });
}
  showErrorCheckBoxClicked()
  {
    this.loadItems();
  }
   isDate(dateStr: any) {
    return !isNaN(new Date(dateStr).getDate());
  }
  ngOnDestroy() {
    this._importComponent.disableImportStep();
  }
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent default behavior of the Enter key
      // Add any additional logic if needed
    }
  }
  _onSelectionChange(e: any)
  {
  }
  _onSelectedKeysChange(e: any) {
    this._indexToBeRemoved = e;
    this.selectedItemsEnable = this._indexToBeRemoved.length > 0;
  }
  public onSelect(event: any): void {
    // Prevent row selection when clicking on the checkbox
    if (event.target.type === 'checkbox') {
      event.preventDefault();
    }
  }
  _removeBatch() {
    if(this.showErrorsOnly)
    {
      var CheckNoErrors = this._dataToImport.filter((x: any) => !x.Error);
      CheckNoErrors.forEach((element: any) => {
        if(this._indexToBeRemoved.includes(element.Id))
        {
          var NoErrorIndex = this._indexToBeRemoved.indexOf(element.Id);
          this._indexToBeRemoved.splice(NoErrorIndex, 1);
        }

      });
    }
    this._dataToImport = this._dataToImport.filter((x: any) => !this._indexToBeRemoved.includes(x.Id));
    this._importComponent.updateImportObject(this._dataToImport);
    this._hasChanges = true;
    this._indexToBeRemoved = [];
    this.selectedItemsEnable = false;
    this.loadItems();
    this.validateData();
    this.uncheckAllCheckboxes();

  }
  public uncheckAllCheckboxes() {
    this._gridView.data.forEach((item) => {
      item.isChecked = false;
    });
    // Refresh the grid
    this.grid.data = this._gridView;
  }
  assign(obj: any, keyPath: any, value: any) {
    let lastKeyIndex = keyPath.length-1;
    for (var i = 0; i < lastKeyIndex; ++ i) {
      let key = keyPath[i];
      if (!(key in obj)){
        obj[key] = {}
      }
      obj = obj[key];
    }
    obj[keyPath[lastKeyIndex]] = value;
 }

  ReCreateListWithCorrectObject(List: any)
  {
    var CorrectList = [];

    for(var i =0; i < List.length;i++)
    {
      var TempObject : any = {};
      var ColumnNames = Object.keys(List[i]);
      for(var x =0; x < ColumnNames.length;x++)
      {
        let ColumnName = ColumnNames[x];
         let CheckIfObject = ColumnName.split(".");
         if(CheckIfObject.length > 1)
         this.assign(TempObject, CheckIfObject,List[i][ColumnName]);
         else TempObject[ColumnName] = List[i][ColumnName];
      }
      CorrectList.push(TempObject);

    }
    return CorrectList;

  }
  validateData() {

const validateObject: ValidateObject = {
  dataToImport: this._importComponent.importObject.dataToImport,
  importUpsertSetting: this._importComponent.importObject.importUpsertSetting,

  //dataToImport:  this._gridView ? this._gridView.data : this._importComponent.importObject.dataToImport,
  accountSites: this._importComponent.importAccounts,
  accountIds: this._importComponent.importAccounts,
};
if(this._selectedModel.labelName == 'purchaseOrders'|| this._selectedModel.modelName == "Purchase Order")
  {
    validateObject.dataToImport.forEach((element: any) => {
        element.address = {name : element["address.name"]}
    });
  }
    if(this._selectedModel.labelName == 'locations')
 {
   validateObject.dataToImport.forEach((element: any) => {
    if(!element.locationType)
    {
      element.locationType = {code: 'Stationary'};
    }
    if(element.locationType && !element.locationType.code)
    {
      element.locationType = {code: 'Stationary'};
    }
    if(element && element.locationType
      && element.locationType.code.toLowerCase().trim() == "pallet")
    {
    //  this._gridColumnsName.forEach(element1 => {
    //   if(element1.entity  == "entityTruck")
    //   element1.entity = 'entityPallet';
    //  });
      // if(!element.entityPallet)
      //   element.entityPallet = {};

      //   if(element.entityTruck && element.entityTruck.homeLocation)
      //   {
      //     if(!element.entityPallet.homeLocation)
      //     element.entityPallet.homeLocation = {};
      //     element.entityPallet.homeLocation.code =element.entityTruck.homeLocation.code;


      //   }
      //   if(element.entityTruck && element.entityTruck.currentLocation)
      //   {
      //     if(!element.entityPallet.currentLocation)
      //     element.entityPallet.currentLocation = {};
      //     element.entityPallet.currentLocation.code =element.entityTruck.currentLocation.code;


      //   }
      // delete element.entityTruck;

    }
   });
 }
 if(this._selectedModel.labelName == 'customers')
 {
   validateObject.dataToImport.forEach((element: any) => {
    if(!element.customerType)
    {
      element.customerType = {code: 'Activity', name: 'Activity'};
    }
    if(element.customerType && !element.customerType.name)
    {
      element.customerType = {code: 'Activity', name: 'Activity'};
    }
    if(!element.entityContact){
      element['entityContact'] = {};
      //element['entityContact'].id = this._model?.entityContact?.id;
    }
    // element['entityContactId'] = this._model?.entityContact?.id;
    if (!element.entityAddress){
      element.entityAddress = {};
      //element['entityAddress'].id = this._model?.entityAddress?.id;
    }
    // element['entityAddressId'] = this._model?.entityAddress?.id;
    if(!element.customerContract){
      element['customerContract'] = {};
      //element['customerContract'].id = this._model?.customerContract?.id;
    }
    // element['customerContractId'] = this._model?.customerContract?.id;
    if(!element.entityTruck){
      element['entityTruck'] = {};
      //element['entityTruck'].id = this._model?.entityTruck?.id;
    }
   });
 }
// validateObject.dataToImport = this.ReCreateListWithCorrectObject(validateObject.dataToImport);
 if(this._selectedModel.labelName == "stockItems")
{
  //validateObject.dataToImport = validateObject.dataToImport.filter((x: any) => x.number);
}
if(this._selectedModel.labelName == "asset-models")
{
  this._selectedModel.labelName = "models"
}
if(this._selectedModel.labelName == "Asset")
{
  this._selectedModel.labelName = "assets"
}
if(this._selectedModel.labelName == "asset-types")
{
  this._selectedModel.labelName = "assettypes"
}

var ValidTypes = this.ValidateTypeAndRequired(validateObject.dataToImport);
// if(!ValidTypes)
// {
//   this.TempDataToImport = [];
//    this.ValidateTypeAndRequired(validateObject.dataToImport, true, this.TempDataToImport);
//   validateObject.dataToImport = this.TempDataToImport;
// }

this.loadItems();
  this._importService
    .validate(this._selectedModel.labelName, validateObject, this._importComponent.isAsset)
    
    .subscribe((data: ValidateImportResultItem[]) => {
      this._dataToImport = validateObject.dataToImport;
      this._errorCount = 0;
      for (let i = 0; i < this._dataToImport.length; i++) {
        this._dataToImport[i]['Id'] = i + 1;
        //this._dataToImport[i]['Id'] = guid();
        if(!this._dataToImport[i]['Error'])
        this._dataToImport[i]['Error'] = '';
        if(data[i].message)
        this._dataToImport[i]['Error'] += data[i].message;
        this._dataToImport[i]['errorTypes'] = Array.isArray(data[i]?.errorTypes) ? data[i].errorTypes : [];


        if (data[i].message || this._dataToImport[i]['Error']) {
          this._errorCount++;
        }

      }

      this.loadItems();

      if (this._errorCount === 0 && this._dataToImport.length > 0) {
        this._importComponent.setCanGoNext(true);
      }
      else
      {
        this._importComponent.setCanGoNext(false);
      }
    },
    (err:any) =>{
    });



  }
   isNotWhitespace(value: string): boolean {
    // Use trim() to remove leading and trailing whitespace, then check if the resulting string is not empty
    if(typeof value === 'string')
    {
      var test = value.trim() !== '';
      return value.trim() !== '';
    }

  return true;
  }
 isNumeric = (val: string) : boolean => {
    return !isNaN(Number(val));
 }
  ValidateTypeAndRequired(DataToImport: any, removeInvalidData: boolean = false, TempRemovedData: any = [])
  {
    this._errorCount = 0;
    var Valid = true;
    let i = 1;
    DataToImport.forEach((element: any) => {
      element['Error'] = undefined;
      element['Id'] = i++;
      //element['Id'] = guid();
    });
    this._gridColumnsName.forEach(grid => {
      DataToImport.forEach((data: any) => {
        var DataOfColumn;
        if(!grid.entity || grid.entity == 'customFieldsValue')
          DataOfColumn = data[grid.name];
        else
        {
          if(grid.entityRelation == "OneToOne")
          {
            if(!grid.fieldName)
            DataOfColumn = data[grid.entity][grid.name];
            else
            DataOfColumn = data[grid.entity][grid.name][grid.fieldName];
          }
          if(grid.entityRelation == "OneToMany")
          {
            if(!grid.fieldName)
            DataOfColumn = data[grid.entity][0][grid.name];
            else
            DataOfColumn = data[grid.entity][0][grid.name][grid.fieldName];
          }
        }

          /// Validate Types //////
            if(grid.type == "string")
            {
              // if(DataOfColumn && typeof DataOfColumn != "string")
              // {
              //   if(!data['Error'])
              //   data['Error'] = '';
              //   data['Error'] += grid.mappedName + " must be characters; ";
              //   Valid = false;
              //data = this.removeDataForUnSuitableTypes(grid, data);
              //DataOfColumn = undefined;

              // }
            }
            if(grid.type == "numeric")
            {
              var test = typeof DataOfColumn;
             // if(DataOfColumn && this.isNotWhitespace(DataOfColumn) && typeof DataOfColumn != "number")
             if(DataOfColumn && this.isNotWhitespace(DataOfColumn) && !this.isNumeric(DataOfColumn))
              {
                if(!data['Error'])
                data['Error'] = '';
                data['Error'] += grid.mappedName + " " +  DataOfColumn + " must be a number; ";
                Valid = false;
               // if(removeInvalidData)
                //data = this.removeDataForUnSuitableTypes(grid, data);
                DataOfColumn = undefined;
              }
              if(DataOfColumn && this.isNotWhitespace(DataOfColumn)&& this.isNumeric(DataOfColumn))
              {
                data = this.setDataForNumber(grid, data);
              }
            }
            if(grid.type == "date")
            {
              var parsedDate = this.isValidDate(DataOfColumn);
              if(DataOfColumn  && this.isNotWhitespace(DataOfColumn) &&  !parsedDate && !this.isValid(DataOfColumn))
              {
                if(!data['Error'])
                data['Error'] = '';
                data['Error'] += grid.mappedName + " " +  DataOfColumn + " must be a date; ";
                Valid = false;
                //if(removeInvalidData)
                //data = this.removeDataForUnSuitableTypes(grid, data);
                DataOfColumn = undefined;
              }
              if(DataOfColumn && this.isNotWhitespace(DataOfColumn) && parsedDate)
              {
                data = this.setDataForDate(grid, data, parsedDate);
                //DataOfColumn = data;
              }
            }
            if(grid.type == "boolean")
            {
              if(DataOfColumn && this.isNotWhitespace(DataOfColumn) && (DataOfColumn.toString().toLowerCase().trim() != "true" && DataOfColumn.toString().toLowerCase().trim() != "false"))
              {
                if(!data['Error'])
                data['Error'] = '';
                data['Error'] += grid.mappedName + " " +  DataOfColumn + " must be 'true' or 'false'; ";
                Valid = false;
                //if(removeInvalidData)
                //data = this.removeDataForUnSuitableTypes(grid, data);
                DataOfColumn = undefined;
              }
            }
             /// Validate Required //////
             if(grid.required && !DataOfColumn && !this.shouldSkipRequiredValidation(grid, data))
             {
              if(!data['Error'])
                data['Error'] = '';
              data['Error'] += grid.mappedName + " is required; ";
              Valid = false;
             }

             if(data['Error'])
             this._errorCount ++;


      });
    });
    //if(!removeInvalidData)
    this._dataToImport = cloneData(DataToImport);
    // else
    // this.TempDataToImport = cloneData(DataToImport);
    return Valid;
  }

  shouldSkipRequiredValidation(grid: any, data: any): boolean {
    if (this._selectedModel?.labelName !== 'stockItems') {
      return false;
    }

    const fieldPath = grid.entity
      ? `${grid.entity}.${grid.name}`
      : grid.name;
    if (fieldPath !== 'costType.code') {
      return false;
    }

    const itemTypeName = this.getCellValue({
      entity: 'itemType',
      entityRelation: 'OneToOne',
      name: 'name'
    }, data);

    return itemTypeName?.toString().trim().toLowerCase().replace(/[\s_-]/g, '') === 'noninventory';
  }

  removeDataForUnSuitableTypes(grid: any, recordRow: any)
  {
    if(!grid.entity || grid.entity == 'customFieldsValue')
   recordRow[grid.name] = undefined;
  else
  {
    if(grid.entityRelation == "OneToOne")
    {
      if(!grid.fieldName)
       recordRow[grid.entity][grid.name] = undefined;
      else
      recordRow[grid.name][grid.entity][grid.name][grid.fieldName] = undefined;
    }
    if(grid.entityRelation == "OneToMany")
    {
      if(!grid.fieldName)
      {
        recordRow[grid.entity][0][grid.name] = undefined;
        recordRow['TempArray ' + grid.entity][grid.name] = undefined;
      }


      else
      {
        recordRow[grid.entity][0][grid.name][grid.fieldName] = undefined;
        recordRow['TempArray ' + grid.name][grid.entity][grid.name][grid.fieldName] = undefined;
      }

    }
  }
  return recordRow;
  }
  ValidateTypeForFormGroup(grid: any, dataItem: any)
  {
    var Valid = true;
    var DataOfColumn;
    if(!grid.entity || grid.entity == 'customFieldsValue')
      DataOfColumn = dataItem[grid.name];
    else
    {
      if(grid.entityRelation == "OneToOne")
      {
        if(!grid.fieldName)
        DataOfColumn = dataItem[grid.entity][grid.name];
        else
        DataOfColumn = dataItem[grid.entity][grid.name][grid.fieldName];
      }
      if(grid.entityRelation == "OneToMany")
      {
        if(!grid.fieldName)
        DataOfColumn = dataItem[grid.entity][0][grid.name];
        else
        DataOfColumn = dataItem[grid.entity][0][grid.name][grid.fieldName];
      }
    }
    if(grid.type == "string")
    {
      return true;
    }
    if(grid.type == "numeric")
    {
      if(DataOfColumn  && !this.isNumeric(DataOfColumn))
      {
        Valid = false;
      }
    }
    if(grid.type == "date")
    {
      if(DataOfColumn  &&  !this.isValid(DataOfColumn))
      {
        Valid = false;
      }
    }
    if(grid.type == "boolean")
    {
      if(DataOfColumn && this.isNotWhitespace(DataOfColumn) && (DataOfColumn.toString().toLowerCase().trim() != "true" && DataOfColumn.toString().toLowerCase().trim() != "false"))
      {

        Valid = false;
      }
    }
    return Valid;
  }
  setDataForNumber(grid: any, recordRow: any)
  {

    if(!grid.entity || grid.entity == 'customFieldsValue')
    {
      //recordRow[grid.name] = new Date(recordRow[grid.name]);
      recordRow[grid.name] = parseFloat(recordRow[grid.name]);

    }

  else
  {
    if(grid.entityRelation == "OneToOne")
    {
      if(!grid.fieldName)
       recordRow[grid.entity][grid.name] = parseFloat(recordRow[grid.entity][grid.name]);
      else
      recordRow[grid.entity][grid.name][grid.fieldName] =parseFloat(recordRow[grid.entity][grid.name][grid.fieldName]);
    }
    if(grid.entityRelation == "OneToMany")
    {
      if(!grid.fieldName)
      {
        recordRow[grid.entity][0][grid.name] = parseFloat(recordRow[grid.entity][0][grid.name]);
        recordRow['TempArray ' + grid.entity][grid.name] = parseFloat(recordRow['TempArray ' + grid.entity][grid.name]);
      }


      else
      {
        recordRow[grid.entity][0][grid.name][grid.fieldName] = parseFloat(recordRow[grid.entity][0][grid.name][grid.fieldName]);
        recordRow['TempArray ' + grid.name][grid.entity][grid.name][grid.fieldName] = parseFloat(recordRow['TempArray ' + grid.name][grid.entity][grid.name][grid.fieldName]);
      }

    }
  }
  return recordRow;
  }
  setDataForDate(grid: any, recordRow: any, parsedDate: any)
  {

    if(!grid.entity || grid.entity == 'customFieldsValue')
    {
      //recordRow[grid.name] = new Date(recordRow[grid.name]);
      recordRow[grid.name] = parsedDate;

    }

  else
  {
    if(grid.entityRelation == "OneToOne")
    {
      if(!grid.fieldName)
       recordRow[grid.entity][grid.name] = parsedDate // new Date(recordRow[grid.entity][grid.name]);
      else
      recordRow[grid.entity][grid.name][grid.fieldName] = parsedDate//new Date(recordRow[grid.entity][grid.name][grid.fieldName]);
    }
    if(grid.entityRelation == "OneToMany")
    {
      if(!grid.fieldName)
      {
        recordRow[grid.entity][0][grid.name] = parsedDate//new Date(recordRow[grid.entity][0][grid.name]);
        recordRow['TempArray ' + grid.entity][grid.name] = parsedDate//new Date(recordRow['TempArray ' + grid.entity][grid.name]);
      }


      else
      {
        recordRow[grid.entity][0][grid.name][grid.fieldName] = parsedDate//new Date(recordRow[grid.entity][0][grid.name][grid.fieldName]);
        recordRow['TempArray ' + grid.name][grid.entity][grid.name][grid.fieldName] = parsedDate//new Date(recordRow['TempArray ' + grid.name][grid.entity][grid.name][grid.fieldName]);
      }

    }
  }
  return recordRow;
  }

//  isValidDate(date: any) {
//     return date && Object.prototype.toString.call(date) === "[object Date]" && !isNaN(date);
//   }
  // isValidDate(date: any) {
  //   return new Date(date).toString() !== "Invalid Date";
  // }
  //  isValidDate(dateString: string): boolean {
  //   const date = new Date(dateString);
  //   return !isNaN(date.getTime());
  // }

//#region Date Validate
isValidDate(dateString: string): Date | null {
  // List of date format patterns to check
  const dateFormats = [
    'yyyy-MM-dd',
    'yyyy/MM/dd',
    'MM-dd-yyyy',
    'MM/dd/yyyy',
    'dd-MM-yyyy',
    'dd/MM/yyyy',
    'yyyy-MM-dd HH:mm:ss',
    'yyyy/MM/dd HH:mm:ss',
    'MM-dd-yyyy HH:mm:ss',
    'MM/dd/yyyy HH:mm:ss',
    'dd-MM-yyyy HH:mm:ss',
    'dd/MM/yyyy HH:mm:ss',
    // Add more formats as needed
  ];

  for (const format of dateFormats) {
    const parsedDate = this.parseDate(dateString, format);
    if (parsedDate !== null) {

      // const customDateFormat = this._dateFormtatPipe.transform(parsedDate);;
      // return  customDateFormat;
      return parsedDate;
    }
  }

  return null; // No valid format found
}
 parseDate(dateString: string, format: string): Date | null {
  if(typeof dateString === 'string')
  {
    const parts = dateString.split(/[-/]/);
    const formatParts = format.split(/[-/]/);

    if (parts.length !== formatParts.length) {
      return null; // Invalid number of date parts
    }

    const dateValues: { [key: string]: number } = {};

    for (let i = 0; i < formatParts.length; i++) {
      const formatPart = formatParts[i];
      const value = parseInt(parts[i], 10);

      if (isNaN(value)) {
        return null; // Invalid numeric value
      }

      dateValues[formatPart] = value;
    }

    // Check if the parsed date is valid (basic range checks)
    if (
      dateValues['yyyy'] < 0 ||
      dateValues['MM'] < 1 ||
      dateValues['MM'] > 12 ||
      dateValues['dd'] < 1 ||
      dateValues['dd'] > 31
    ) {
      return null;
    }

    // Create a Date object
    return new Date(
      dateValues['yyyy'],
      dateValues['MM'] - 1, // Month is 0-based in JavaScript
      dateValues['dd']
    );
  }
  else
  return null;

}

 formatDate(date: Date): string {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');

  return `${year}-${month}-${day}`;
}
//#endregion

  private loadItems(): void {

    this._gridView = {
       data: this.showErrorsOnly == true ? [...this._dataToImport.filter((x:any) => x.Error) ] : [...this._dataToImport],
      //total: this.showErrorsOnly == true ? this._dataToImport.filter((x:any) => x.Error).length : this._dataToImport.length,
      total: this._dataToImport.length,
    };
    //this._originalData = cloneData(this._dataToImport);
    this._importComponent.updateImportObject(this._dataToImport);
  }

  // work with editable grid
  _pageGridChange(event: PageChangeEvent): void {
    this._skip = event.skip;
    this.loadItems();
  }
  EditCellMode: boolean = false;
  _cellClickHandler({ sender, rowIndex, columnIndex, dataItem, isEdited }: any) {
    if (!isEdited) {
      this.gridFileds = this.createFormGroup(dataItem);
      sender.editCell(rowIndex, columnIndex, this.gridFileds);
     // this.EditCellMode = true;
    }
  }
   isValid(date: any) {
    if(date)
    {
      if ( Object.prototype.toString.call(date) === "[object Date]") {
        if ( !isNaN(date.getTime()) ) {
           return true;
        } else {
           return false;
        }
     } else {
        return false;
     }
    }
    else
    return false;

 }
  _cellCloseHandler(args: any) {
    //this.EditCellMode = false;
    var { formGroup, dataItem } = args;
    if (!formGroup.valid) {
      // prevent closing the edited cell if there are invalid values.
      args.preventDefault();
    } else if (formGroup.dirty || !formGroup.dirty) {

      // Object.assign(dataItem, formGroup.value);
      dataItem = Object.assign(formGroup.value, {});
      var CheckUpdatedRow = this._dataToImport.find((x: any) => x.Id ==  dataItem.Id);
      //var CheckUpdatedRow = this._dataToImport[args.rowIndex];
        if(CheckUpdatedRow)
        {
           var UpdatedRowIndex = this._dataToImport.findIndex((x: any) => x.Id ==  CheckUpdatedRow.Id);
           //var UpdatedRowIndex = args.rowIndex;
          var fieldSplit = args.column.field.split(".");
          if(fieldSplit.length > 1)
          {
            if(fieldSplit.length == 2)
           {
            if(this.isValid( dataItem[
              fieldSplit[0]]
            [fieldSplit[1]]))
            {
              this._dataToImport[UpdatedRowIndex][fieldSplit[0]][fieldSplit[1]] =
              this._dateFormtatPipe.transform(dataItem[
                fieldSplit[0]]
              [fieldSplit[1]]);
            }
            else
            {
              this._dataToImport[UpdatedRowIndex][fieldSplit[0]][fieldSplit[1]] =
              dataItem[
               fieldSplit[0]]
             [fieldSplit[1]];
            }

           }

            if(fieldSplit.length == 3)
            {
              if(this.isValid(dataItem[args.column.field]))
              {
                this._dataToImport[UpdatedRowIndex][fieldSplit[0]][fieldSplit[1]][fieldSplit[2]] =
                this._dateFormtatPipe.transform(  dataItem[
                  fieldSplit[0]]
                [fieldSplit[1]]
                [fieldSplit[2]]);
              }
              else
              {
                this._dataToImport[UpdatedRowIndex][fieldSplit[0]][fieldSplit[1]][fieldSplit[2]] =
                dataItem[
                 fieldSplit[0]]
               [fieldSplit[1]]
               [fieldSplit[2]];
              }

            }

          }
          else
          {
            if(this.isValid(dataItem[args.column.field]))
            {
              this._dataToImport[UpdatedRowIndex][args.column.field] = this._dateFormtatPipe.transform(dataItem[args.column.field]);
            }
            else
            this._dataToImport[UpdatedRowIndex][args.column.field] = dataItem[args.column.field];
          }
          if(this._dataToImport[UpdatedRowIndex].customFieldsValue
             && this._dataToImport[UpdatedRowIndex].customFieldsValue.length > 0)
          {
            for (let customField of  this._dataToImport[UpdatedRowIndex].customFieldsValue) {
              if(customField.hasOwnProperty(args.column.field))
              {
                customField[args.column.field] = dataItem[args.column.field];
              }
            }

          }

          for (const [key, value] of Object.entries(this._dataToImport[UpdatedRowIndex])) {
            if(key.includes('TempArray') && !key.includes('TempArray customFieldsValue')
          )
            {
              var KeyWithoutTempArray = key.split('TempArray ')[1];
              this._dataToImport[UpdatedRowIndex][KeyWithoutTempArray][0] = this._dataToImport[UpdatedRowIndex][key]
            }
          }
           this._importComponent.updateImportObject(this._dataToImport);
        }
      this._hasChanges = true;
     // this.loadItems();
      this.validateData();
    }
  }

  _addHandler({ sender }: any) {
    sender.addRow(this.createFormGroup());
  }

  _cancelHandler({ sender, rowIndex }: any) {
    sender.closeRow(rowIndex);
  }

  _saveHandler({ sender, formGroup, rowIndex }: any) {
    if (formGroup.valid) {
      Object.keys(formGroup.value).forEach(formGroupItem => {
        if(formGroupItem.includes('TempArray')) // One To Many Relation
        {
          var KeyWithoutTempArray = formGroupItem.split('TempArray ')[1];
          if(!formGroup.value[KeyWithoutTempArray])
          formGroup.value[KeyWithoutTempArray] = [{}];
          formGroup.value[KeyWithoutTempArray][0] = formGroup.value[formGroupItem];
        }
        this._gridColumnsName.forEach(element => {
          if(element.entity == 'customFieldsValue')
          {
            if(formGroupItem == element.name)
            {
              if(!formGroup.value[element.entity])
              formGroup.value[element.entity] = [];
              //{

                var customFieldObject = {
                  [element.name] : formGroup.value[element.name]
                }
                formGroup.value[element.entity].push(customFieldObject)

            //}
            }
          }
        });
      });

      this._dataToImport.push(formGroup.value);
      sender.closeRow(rowIndex);
      this.loadItems();
      this.validateData();
      this._hasChanges = true;
    }
  }

  _removeHandler({ sender, dataItem }: any) {
    const flags: PersonImportErrorType[] = dataItem?.errorTypes ?? [];
    const isPersons = this.isPersonsImport();
    const removeAllSameEmail = isPersons && flags.includes(PersonImportErrorType[this.PersonImportErrorType.personEmailDuplicateInFile] as any);
    const removeAllSameCode = isPersons && flags.includes(PersonImportErrorType[this.PersonImportErrorType.personCodeDuplicateInFile] as any);

    if (removeAllSameEmail || removeAllSameCode) {
      const targetEmail = removeAllSameEmail ? dataItem.entityContact?.email : undefined;
      const targetCode = removeAllSameCode ? dataItem.code : undefined;
      this._dataToImport = this._dataToImport.filter((row: any) => {
        if (row.Id === dataItem.Id) return true; // keep the clicked row
        if (targetEmail != null && targetEmail !== '' && row.entityContact?.email === targetEmail) return false;
        if (targetCode != null && targetCode !== '' && row.code === targetCode) return false;
        return true;
      });
    } else {
      const index = itemIndex(dataItem, this._dataToImport);
      this._dataToImport.splice(index, 1);
    }
    this._indexToBeRemoved = [];
    this.selectedItemsEnable = false;
    sender.cancelCell();
    this._hasChanges = true;
    this.loadItems();
    this.validateData();

  }

  _cancelChanges(grid: any): void {
    grid.cancelCell();

    this._dataToImport = cloneData(this._originalData);
    this._hasChanges = false;
    this.loadItems();
    this.validateData();

  }
  parseData(data: any, validators?: any): FormGroup | FormArray | [any, ValidatorFn[], AsyncValidatorFn[]] {
    if (Array.isArray(data)) {
      return this.formBuilder.array(data.map((item, index) => this.parseData(item, (validators || {})[index])));
    }
    if (typeof data === 'object' && data !== null) {
      const formGroupContent : any = {};
      for (const [key, value] of Object.entries(data)) {
        formGroupContent[key] = this.parseData(value, (validators || {})[key]);
      }
      return this.formBuilder.group(formGroupContent);
    }
    const [syncValidators = [], asyncValidators = []] = validators || [];
    return [data, syncValidators, asyncValidators];
  }
  private createFormGroup(dataItem: any = null): FormGroup {


    const record: NewRecordObject = {};

    if (dataItem) {
      record['Id'] = dataItem.Id;
    } else {
      record['Id'] = this._dataToImport.length + 1;
      //record['Id'] = guid;
    }

    this._gridColumnsName.forEach((element) => {
      if(!element.entity || element.entity == 'customFieldsValue')
      {
        if (dataItem) {
           var ValidType = this.ValidateTypeForFormGroup(element, dataItem);
           if(ValidType)
            record[element.name] = dataItem[element.name];
           else
           record[element.name] = null;
        } else {
          record[element.name] = null;
        }
      }
      if(element.entity && element.entityRelation == 'OneToOne')
      {
        if (dataItem && this.ValidateTypeForFormGroup(element, dataItem)) {
          if(!element.fieldName)
          {
            if(!record[element.entity] )
            {
              record[element.entity] = this.formBuilder.group({
                [element.name]: dataItem[element.entity][element.name]
             });

            }
            else
            {
              record[element.entity].addControl(
                [element.name], new FormControl(dataItem[element.entity][element.name]));
            }

          }

          else
          {

            if(!record[element.entity] )
            {

              record[element.entity] = this.formBuilder.group({
                [element.name]: this.formBuilder.group({
                  [element.fieldName]:  dataItem[element.entity][element.name][element.fieldName]})


             });
            }
            else
            {
              if(record[element.entity])
              {
                if(!record[element.entity].controls[element.name])
                {
                  record[element.entity].addControl([element.name], this.formBuilder.group({
                    [element.fieldName]:  dataItem[element.entity][element.name][element.fieldName]}));
                }
                else
                {
                    record[element.entity].controls[element.name].addControl([element.fieldName], new FormControl( dataItem[element.entity][element.name][element.fieldName]));
                }

              }


            }

          }

        } else {
          if(!element.fieldName)
          {
            if(!record[element.entity] )
            {

              record[element.entity] = this.formBuilder.group({
                [element.name]: null
             });
            }
            else
            {

            record[element.entity].addControl(
              [element.name], new FormControl());
            }


          }

          else
          {
            if(!record[element.entity] )
            {

              record[element.entity] = this.formBuilder.group({
                [element.name]: this.formBuilder.group({
                  [element.fieldName]:  null})


             });
            }
            else
            {
              if(!record[element.entity].controls[element.name])
                {
                  record[element.entity].addControl([element.name], this.formBuilder.group({
                    [element.fieldName]:  new FormControl(null)}));
                }
                else
                {
                    record[element.entity].controls[element.name].addControl([element.fieldName], new FormControl(null));
                }
            }
          }

        }
      }
      // New Condition
      if(element.entity && element.entityRelation == 'OneToMany')
      {
        if (dataItem && this.ValidateTypeForFormGroup(element, dataItem)) {
          if(!element.fieldName)
          {
            if(!record['TempArray ' + element.entity] )
            {
              record['TempArray ' + element.entity] = this.formBuilder.group({
                [element.name]: dataItem['TempArray ' + element.entity][element.name]
             });

            }
            else
            {
              record['TempArray ' + element.entity].addControl(
                [element.name], new FormControl(dataItem['TempArray ' + element.entity][element.name]));
            }

          }

          else
          {

            if(!record['TempArray ' + element.entity] )
            {

              record['TempArray ' + element.entity] = this.formBuilder.group({
                [element.name]: this.formBuilder.group({
                  [element.fieldName]:  dataItem['TempArray ' + element.entity][element.name][element.fieldName]})


             });
            }
            else
            {
              if(record['TempArray ' + element.entity])
              {
                if(!record['TempArray ' + element.entity].controls[element.name])
                {
                  record['TempArray ' + element.entity].addControl([element.name], this.formBuilder.group({
                    [element.fieldName]:  dataItem['TempArray ' + element.entity][element.name][element.fieldName]}));
                }
                else
                {
                    record['TempArray ' + element.entity].controls[element.name].addControl([element.fieldName], new FormControl( dataItem[element.entity][element.name][element.fieldName]));
                }

              }
            }

          }

        } else {
          if(!element.fieldName)
          {
            if(!record['TempArray ' + element.entity] )
            {

              record['TempArray ' + element.entity] = this.formBuilder.group({
                [element.name]: null
             });
            }
            else
            {

            record['TempArray ' + element.entity].addControl(
              [element.name], new FormControl());
            }


          }

          else
          {
            if(!record['TempArray ' + element.entity] )
            {

              record['TempArray ' + element.entity] = this.formBuilder.group({
                [element.name]: this.formBuilder.group({
                  [element.fieldName]:  null})


             });
            }
            else
            {
              if(!record['TempArray ' + element.entity].controls[element.name])
                {
                  record['TempArray ' + element.entity].addControl([element.name], this.formBuilder.group({
                    [element.fieldName]:  new FormControl(null)}));
                }
                else
                {
                    record['TempArray ' + element.entity].controls[element.name].addControl([element.fieldName], new FormControl(null));
                }
            }
          }

        }
      }

    });

    return  this.formBuilder.group(record);

  }

  getErrorsCount(dataToImport: any)
  {
    return dataToImport.filter((x: any) => x.Error).length;
  }

  isPersonsImport(): boolean {
    const labelName = this._selectedModel?.labelName;
    return labelName === 'users' || labelName === 'persons';
  }

  cellHasError(field: any, dataItem: any): boolean {
    if (!dataItem) return false;
    const fieldFlags = this.getFieldErrorFlags(field);
    if (!fieldFlags.length) return false;
    const rowFlags: PersonImportErrorType[] = dataItem.errorTypes ?? [];
    return rowFlags.some(f => fieldFlags.includes(f));
  }

  getCellValue(field: any, dataItem: any): any {
    if (!field || !dataItem) return '';
    if (!field.entity || field.entity === 'customFieldsValue') {
      return dataItem[field.name];
    }
    if (field.entityRelation === 'OneToOne') {
      const entityVal = dataItem[field.entity];
      if (!entityVal) return '';
      if (!field.fieldName) return entityVal[field.name];
      return entityVal[field.name] ? entityVal[field.name][field.fieldName] : '';
    }
    return dataItem[field.name];
  }

  private getFieldErrorFlags(field: any): PersonImportErrorType[] {
    if (!this.isPersonsImport()) return [];
    const path = field.entity
      ? `${field.entity}.${field.name}${field.fieldName ? '.' + field.fieldName : ''}`
      : field.name;
    switch (path) {
      case 'email':
        return [
          PersonImportErrorType.personEmailInvalid,
          PersonImportErrorType.personEmailAlreadyExists,
          PersonImportErrorType.personEmailDuplicateInFile,
        ];
      case 'person.code':
        return [
          PersonImportErrorType.personCodeAlreadyExists,
          PersonImportErrorType.personCodeNotFound,
          PersonImportErrorType.personCodeDuplicateInFile,
        ];
      case 'department':
        return [PersonImportErrorType.departmentCodeNotFound];
      case 'manager':
        return [PersonImportErrorType.managerCodeNotFound];
      case 'site.code':
        return [PersonImportErrorType.siteCodeNotFound];
      default:
        return [];
    }
  }

}
